import { ResourceOptions } from 'react-admin';
import { FaStar } from 'react-icons/fa';
import { Resources } from '../resource';

export { default as list } from './List';

export const name = Resources.perpsV1Presets;
export const icon = FaStar;
export const options: ResourceOptions = {
  label: 'resource.perpsV1Presets',
};
